module.exports = __webpack_public_path__ + "img/Mathematiques_analyse-1536x864.00a2dd11.jpg";